import React from "react";
import styles from './FooterMobile.module.css';

function SocialIcon({ src }) {
  return <img loading="lazy" src={src} alt="Social media icon" className={styles.socialIcon} />;
}

export default SocialIcon;